import { render } from "./dynamicForm.vue?vue&type=template&id=623160df&scoped=true"
import script from "./dynamicForm.vue?vue&type=script&lang=js"
export * from "./dynamicForm.vue?vue&type=script&lang=js"

import "./dynamicForm.vue?vue&type=style&index=0&id=623160df&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623160df"]])

export default __exports__